import { queryParams } from '~/scripts/lib/utils/url';

export function isLoggedInLayout() {
  return !!$("body").data('loggedin');
}

export function setupSessionInactivityCheckTimer() {
  if(isLoggedInLayout()){
    var duration = gon.user_session.session_check_interval * 1000; // convert to ms
    if(!duration) return; // double check to avoid using the very low default value

    window.R.checkExpiredSessionIntervalId = setInterval(checkSessionExpired, duration);
    // To keep track of sessions across multiple tabs
    var currentTime = new Date();
    var pingSessionCheckAt = currentTime.getTime() + duration;
    localStorage.setItem("pingSessionCheckAt", pingSessionCheckAt);
  }
}

export function checkSessionExpired() {
  var email = $("body").data('email');
  var dataOpts = {
    session_check: true
  };
  var anchorTag = window.location.hash;
  var currentQueryParams = queryParams();

  if(anchorTag){
    dataOpts.anchor_tag = anchorTag;
  }

  if(currentQueryParams.viewer){
    dataOpts.viewer = currentQueryParams.viewer;
  }
  var sessionCheckEndpoint = "/" + gon.user_session.session_check_endpoint;

  $.get(sessionCheckEndpoint, dataOpts, function(data, status){
    if(!data.status){
      localStorage.removeItem("pingSessionCheckAt");
      var idp = new window.R.IdpRedirecter();
      var current_network = gon.user_session.current_network;
      idp.checkIdp(email, null, {session_expired: "true", network: current_network});
    }
    else{
      var currentTime = +new Date();
      var pingSessionCheckAt = localStorage.getItem("pingSessionCheckAt");

      if(currentTime < pingSessionCheckAt){
        var remainingTime = pingSessionCheckAt - currentTime;
        // setting the minimum to 2 secs to prevent possibility of
        // multiple session check requests.
        if(remainingTime < 2000){
          remainingTime = 2000;
        }
        window.R.checkExpiredSessionIntervalId = setTimeout(checkSessionExpired, remainingTime);
      }
    }
  });
}
